/**
 * Module: slots API
 * Role: Slot helpers for /api/v2/buyer/slots (BUG-1309)
 * Uses: ./client (apiFetch)
 * Used by: FlowScreen (cancel CTA), FindsScreen
 */
import { apiFetch } from './client';

export interface SlotListItem {
  id: string;
  offer_id: string;
  campaign_id: string;
  status: string;
  current_step: number;
  reward_kopecks: number;
  deadline_at: string | null;
  created_at: string;
  product_title?: string | null;
  product_image_url?: string | null;
  marketplace?: string | null;
}

export interface SlotListResponse {
  items: SlotListItem[];
  meta: { total: number; limit: number; offset: number; has_next: boolean };
}

export interface CancelSlotResponse {
  slot_id: string;
  status: string;
}

const TAKEN_SLOTS_PAGE_LIMIT = 20;

export async function fetchTakenSlotsPage(offset: number): Promise<SlotListResponse> {
  return apiFetch<SlotListResponse>(
    `/api/v2/buyer/slots?status=all_taken&limit=${TAKEN_SLOTS_PAGE_LIMIT}&offset=${offset}`,
  );
}

export function getNextSlotsPageParam(
  lastPage: SlotListResponse,
): number | undefined {
  if (lastPage.meta.has_next) {
    return lastPage.meta.offset + lastPage.meta.limit;
  }
  return undefined;
}

export async function cancelSlot(slotId: string): Promise<CancelSlotResponse> {
  return apiFetch<CancelSlotResponse>(
    `/api/v2/buyer/slots/${slotId}/cancel`,
    { method: 'POST' },
  );
}
